"use strict";

module.exports = {
  CUSTOM_SIGNS: 'Custom Signs',
  CUSTOM_SIGN_REPRINTS: 'Custom Sign Reprints',
  FAVOR_TAGS: 'Favor Tags',
  FAVOR_TAG_REPRINTS: 'Favor Tag Reprints',
  SEATING_CHARTS: 'Seating Charts',
  SEATING_CHART_REPRINTS: 'Seating Chart Reprints',
  TABLE_NUMBERS: 'Table Numbers',
  TABLE_NUMBER_REPRINTS: 'Table Number Reprints',
  PLACE_CARDS: 'Place Cards',
  PLACE_CARD_REPRINTS: 'Place Card Reprints',
  WEDDING_MENUS: 'Wedding Menus',
  WEDDING_MENU_REPRINTS: 'Wedding Menu Reprints',
  LETTERPRESS_WEDDING_MENUS: 'Letterpress Wedding Menus',
  LETTERPRESS_WEDDING_MENU_REPRINTS: 'Letterpress Wedding Menu Reprints',
  WELCOME_SIGNS: 'Welcome Signs',
  WELCOME_SIGN_REPRINTS: 'Welcome Sign Reprints',
  RESERVED_SIGNS: 'Reserved Signs',
  RESERVED_SIGN_REPRINTS: 'Reserved Sign Reprints',
  WEDDING_SIGNS: 'Wedding Signs',
  WEDDING_SIGN_REPRINTS: 'Wedding Sign Reprints'
};